module.exports = __webpack_public_path__ + "media/images/gifts/sensations/sug_sensorial_1-6253dd570f07df9c91c19014966867bd.jpg";